export interface ErrorDto {
  code: string;
}

export const ErrorGeneric: ErrorDto = {
  code: 'Something went wrong'
}

export const getErrorDtoFromApiError = (error: any): ErrorDto => {
  if (!error.response || error.response.status === 500) {
    return ErrorGeneric;
  }
  return error.response.data;
}
